import { createAsyncLocalStorage } from './async-local-storage';
export const workAsyncStorageInstance = createAsyncLocalStorage();

//# sourceMappingURL=work-async-storage-instance.js.map